/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_Step_Next_NoteInputs */

const en_scrape_router_step_next_note = /** @type {(inputs: Scrape_Router_Step_Next_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only if the page blocks it`)
};

const zh_hans1_scrape_router_step_next_note = /** @type {(inputs: Scrape_Router_Step_Next_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅当页面拦截上一个时`)
};

const pt_br2_scrape_router_step_next_note = /** @type {(inputs: Scrape_Router_Step_Next_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só se a página bloquear o anterior`)
};

const es_scrape_router_step_next_note = /** @type {(inputs: Scrape_Router_Step_Next_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo si la página bloquea el anterior`)
};

const fr_scrape_router_step_next_note = /** @type {(inputs: Scrape_Router_Step_Next_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seulement si la page bloque le précédent`)
};

const de_scrape_router_step_next_note = /** @type {(inputs: Scrape_Router_Step_Next_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur wenn die Seite den vorigen blockiert`)
};

const ru_scrape_router_step_next_note = /** @type {(inputs: Scrape_Router_Step_Next_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только если страница блокирует предыдущий`)
};

const it_scrape_router_step_next_note = /** @type {(inputs: Scrape_Router_Step_Next_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo se la pagina blocca il precedente`)
};

/**
* | output |
* | --- |
* | "Only if the page blocks it" |
*
* @param {Scrape_Router_Step_Next_NoteInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_step_next_note = /** @type {((inputs?: Scrape_Router_Step_Next_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_Step_Next_NoteInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_step_next_note(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_step_next_note(inputs)
	if (locale === "es") return es_scrape_router_step_next_note(inputs)
	if (locale === "fr") return fr_scrape_router_step_next_note(inputs)
	if (locale === "de") return de_scrape_router_step_next_note(inputs)
	if (locale === "ru") return ru_scrape_router_step_next_note(inputs)
	if (locale === "it") return it_scrape_router_step_next_note(inputs)
	return en_scrape_router_step_next_note(inputs)
});